import { Box, Flex, FlexboxProps, keyframes, Stack } from '@chakra-ui/react'
import CertifiedIcon from 'components/svg/CertifiedIcon'
import { H6 } from 'components/typography'
import { FC } from 'react'

const scrollerData = [
  'Tratamentos personalizados',
  'Livre de estigmas',
  'Atendimentos flexíveis',
  'Embalagem discreta',
  'Fornecedores certificados'
]

const ScrollingBannerSection: FC = () => {
  return (
    <Box bg="alabaster" py={{ base: '24px', lg: '32px' }} px="24px">
      <Box h={{ base: '56px', lg: '80px' }} overflow="hidden" rounded="full" maxWidth="1310px" mx="auto">
        <AutoScroller />
      </Box>
    </Box>
  )
}

export default ScrollingBannerSection

const AutoScroller: FC = () => {
  const movePrimary = keyframes`
  from { left: 0%; }
  to { left: -100%; }
  `
  const moveSecondary = keyframes`
  from { left: 100%; }
  to { left: 0%; }
  `
  const animationPrimary = `${movePrimary} 12s linear infinite`
  const animationSecondary = `${moveSecondary} 12s linear infinite`

  return (
    <Box bg="gray">
      <Stack w={{ base: '1100px', lg: '1440px' }} position="relative" spacing="0">
        <ScrollElement data={scrollerData} animation={animationPrimary} />
        <ScrollElement data={scrollerData} animation={animationSecondary} />
      </Stack>
    </Box>
  )
}

interface TextItemProps {
  text: string
}

const TextItem: FC<TextItemProps> = ({ text }) => (
  <Flex gap={2} alignItems="center">
    <CertifiedIcon width={{ base: '18px', lg: '22px' }} strokeWidth={4} />
    <H6>{text}</H6>
  </Flex>
)

interface ScrollElementProps extends FlexboxProps {
  animation: string
  data: string[]
}

const ScrollElement: FC<ScrollElementProps> = ({ animation, data }) => (
  <Flex
    w="full"
    animation={animation}
    gap="32px"
    px={4}
    py={{ base: '13px', lg: '25px' }}
    position="absolute"
    top="0%"
    left="0%"
    bg="dandelion"
  >
    {data.map((item, index) => (
      <TextItem key={index} text={item} />
    ))}
  </Flex>
)
